var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGasLiftManager(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 854,
    height: 790,
    viewBox: "0 0 854 790",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3058_2705)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.26351 495.602H853.393V617.779L780.204 569.404L673.86 614.677L566.263 569.403L473.057 655.61L372.341 684.14L327.928 647.548L292.896 594.831L259.742 626.462L185.926 565.062L134.63 572.505L77.0795 523.509L2.63916 504.904L3.26351 495.602Z",
    fill: "#384252",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.26384 495.602V496.203H852.787V616.655L780.267 568.722L673.859 614.023L566.139 568.697L472.75 655.071L372.483 683.474L328.385 647.142L293.001 593.896L259.714 625.653L186.108 564.428L134.816 571.869L77.3663 522.961L3.27796 504.443L3.86903 495.642L3.26384 495.602V496.203V495.602L2.65865 495.562L2 505.364L76.7934 524.058L134.445 573.14L185.745 565.697L259.769 627.27L292.792 595.767L327.47 647.953L372.201 684.805L473.364 656.148L566.39 570.109L673.861 615.331L780.141 570.085L854 618.903V495H2.69597L2.65865 495.562L3.26384 495.602Z",
    fill: "#384252"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.26384 495.602V496.203H852.787V616.655L780.267 568.722L673.859 614.023L566.139 568.697L472.75 655.071L372.483 683.474L328.385 647.142L293.001 593.896L259.714 625.653L186.108 564.428L134.816 571.869L77.3663 522.961L3.27796 504.443L3.86903 495.642L3.26384 495.602ZM3.26384 495.602V496.203V495.602ZM3.26384 495.602L2.65865 495.562L2 505.364L76.7934 524.058L134.445 573.14L185.745 565.697L259.769 627.27L292.792 595.767L327.47 647.953L372.201 684.805L473.364 656.148L566.39 570.109L673.861 615.331L780.141 570.085L854 618.903V495H2.69597L2.65865 495.562L3.26384 495.602Z",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_3058_2705)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M315.77 427.29H303.77V443.39H315.77V427.29Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.81 271.64H485.81V287.74H497.81V271.64Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M615.02 277.29H456.78V291.74H615.02V277.29Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.41 619.54H411.71V744.64H466.41V619.54Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.61 588.54V745.54H467.41L467.61 575.04",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.61 588.54V745.54H467.41L467.61 575.04",
    stroke: "#F7F9F9",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.02 590.84L477.32 573.34L402.02 590.84Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.02 590.84L477.32 573.34",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.02 739.24L361.22 735.74L410.82 732.84",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.02 739.24L361.22 735.74L410.82 732.84",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.02 722.44L361.02 719.54L410.82 716.04",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.02 722.44L361.02 719.54L410.82 716.04",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.02 715.04L515.52 719.04L467.02 722.84",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.02 715.04L515.52 719.04L467.02 722.84",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.41 732.14L515.71 737.04L467.31 740.14",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.41 732.14L515.71 737.04L467.31 740.14",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.51 580.44V492.74H466.11V568.24",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.51 580.44V492.74H466.11V568.24",
    stroke: "#F7F9F9",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.71 493.74L410.61 510.34L465.61 501.44V493.64L410.71 493.74Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.21 525.04V509.44L456.61 503.34V519.24L420.21 525.04Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.21 524.94L419.81 578.14L420.21 524.94Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.21 524.94L419.81 578.14",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.61 518.64V570.24V518.64Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.61 518.64V570.24",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.51 696.64H411.61V709.14H430.51V696.64Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.21 708.44L411.71 696.54L430.21 708.44Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.21 708.44L411.71 696.54",
    stroke: "#F7F9F9",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.91 708.24L430.11 696.94L411.91 708.24Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.91 708.24L430.11 696.94",
    stroke: "#F7F9F9",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.51 685.24H458.11H448.51Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.51 685.24H458.11",
    stroke: "#F7F9F9",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.41 686.54V674.14V686.54Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.41 686.54V674.14",
    stroke: "#F7F9F9",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.41 575.74L429.51 524.14L448.21 521.24L448.41 571.34L429.41 575.74Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.02 432.56H55.02V447.76H174.02V432.56Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.02 432.56H225.02V447.76H454.02V432.56Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.41 368.44H418.91V390.04H459.41V368.44Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.91 477.54H399.91V487.54H474.91V477.54Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.71 485.54H395.71V494.54H478.71V485.54Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.01 416.44H409.61V477.34H468.01V416.44Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.01 421.64H401.01V425.14H407.01V421.64Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.61 421.64H409.61V425.14H415.61V421.64Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.31 421.64H418.31V425.14H424.31V421.64Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.91 421.64H426.91V425.14H432.91V421.64Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.51 421.64H435.51V425.14H441.51V421.64Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.21 421.64H444.21V425.14H450.21V421.64Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.81 421.64H452.81V425.14H458.81V421.64Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.41 421.64H461.41V425.14H467.41V421.64Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.11 421.64H470.11V425.14H476.11V421.64Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M481.51 386.84H395.71V422.14H481.51V386.84Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.01 383.64H401.01V387.14H407.01V383.64Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.61 383.64H409.61V387.14H415.61V383.64Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.31 383.64H418.31V387.14H424.31V383.64Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.91 383.64H426.91V387.14H432.91V383.64Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.51 383.64H435.51V387.14H441.51V383.64Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.21 383.64H444.21V387.14H450.21V383.64Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.81 383.64H452.81V387.14H458.81V383.64Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.41 383.64H461.41V387.14H467.41V383.64Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.11 383.64H470.11V387.14H476.11V383.64Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.31 416.64C440.574 416.64 442.41 414.804 442.41 412.54C442.41 410.276 440.574 408.44 438.31 408.44C436.046 408.44 434.21 410.276 434.21 412.54C434.21 414.804 436.046 416.64 438.31 416.64Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.71 404.14H481.51H395.71Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.71 404.14H481.51",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.01 330.74H429.71V368.04H448.01V330.74Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.91 267.24H482.61V271.14H500.91V267.24Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.17 260.72H474.77V266.92H508.17V260.72Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.4 243.94H476.7V260.94H506.4V243.94Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.78 742.64L430.48 585.54L449.18 580.54L449.02 742.96L431.78 742.64Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 1.13
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.81 581.54L477.21 564.54L402.81 581.54Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.81 581.54L477.21 564.54",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.01 695.54H449.01V708.04H468.01V695.54Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.31 707.24L448.81 696.04L467.31 707.24Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.31 707.24L448.81 696.04",
    stroke: "#F7F9F9",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.02 708.14L468.22 695.54L449.02 708.14Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.02 708.14L468.22 695.54",
    stroke: "#F7F9F9",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.02 604.64H458.62H449.02Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.02 604.64H458.62",
    stroke: "#F7F9F9",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.02 624.44H458.62H449.02Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.02 624.44H458.62",
    stroke: "#F7F9F9",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.02 643.84H458.62H449.02Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.02 643.84H458.62",
    stroke: "#F7F9F9",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.02 664.04H458.62H449.02Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.02 664.04H458.62",
    stroke: "#F7F9F9",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.61 604.94V592.44V604.94Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.61 604.94V592.44",
    stroke: "#F7F9F9",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.61 625.14V612.64V625.14Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.61 625.14V612.64",
    stroke: "#F7F9F9",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.61 644.54V632.04V644.54Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.61 644.54V632.04",
    stroke: "#F7F9F9",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.61 664.64V652.14V664.64Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.61 664.64V652.14",
    stroke: "#F7F9F9",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.51 708.84H412.21V744.64H467.51V708.84Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.41 707.14H431.81V709.54H448.41V707.14Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491.71 244.24C503.639 244.24 513.31 234.569 513.31 222.64C513.31 210.711 503.639 201.04 491.71 201.04C479.781 201.04 470.11 210.711 470.11 222.64C470.11 234.569 479.781 244.24 491.71 244.24Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491.81 242.34C502.69 242.34 511.51 233.52 511.51 222.64C511.51 211.76 502.69 202.94 491.81 202.94C480.93 202.94 472.11 211.76 472.11 222.64C472.11 233.52 480.93 242.34 491.81 242.34Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.02 235.14L480.12 232.14L476.02 235.14Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.02 235.14L480.12 232.14",
    stroke: "#F7F9F9",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.81 234.84L503.11 232.24L506.81 234.84Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.81 234.84L503.11 232.24",
    stroke: "#F7F9F9",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.11 221.84H511.11H508.11Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.11 221.84H511.11",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.21 217.84L475.91 218.34L473.21 217.84Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.21 217.84L475.91 218.34",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.91 211.44L478.11 213.44L475.91 211.44Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.91 211.44L478.11 213.44",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.21 206.74L482.01 209.54L480.21 206.74Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.21 206.74L482.01 209.54",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.81 204.04L486.91 207.44L485.81 204.04Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.81 204.04L486.91 207.44",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.02 203.14V206.64V203.14Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.02 203.14V206.64",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.02 203.84L496.72 206.94L498.02 203.84Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.02 203.84L496.72 206.94",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.41 206.24L501.31 208.84L503.41 206.24Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.41 206.24L501.31 208.84",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.31 210.94L505.21 212.54L507.31 210.94Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.31 210.94L505.21 212.54",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.21 216.24L507.81 217.34L510.21 216.24Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.21 216.24L507.81 217.34",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.41 228.04L473.61 229.34L476.41 228.04Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.41 228.04L473.61 229.34",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491.91 222.04L499.11 209.64L491.91 222.04Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491.91 222.04L499.11 209.64",
    stroke: "#F7F9F9",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491.91 225.54C493.456 225.54 494.71 224.286 494.71 222.74C494.71 221.194 493.456 219.94 491.91 219.94C490.363 219.94 489.11 221.194 489.11 222.74C489.11 224.286 490.363 225.54 491.91 225.54Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.61 227.44L510.11 228.34L507.61 227.44Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.61 227.44L510.11 228.34",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.81 223.24H475.41H472.81Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.81 223.24H475.41",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.02 300.74H432.68V330.22H446.02V300.74Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546.68 275.59H531.78V295.39H546.68V275.59Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542.38 271.19H536.28V299.19H542.38V271.19Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.02 274.51H452.02V294.31H457.02V274.51Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.65 298.74H430.35V303.06H448.65V298.74Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.8 298.74H447.02C447.02 292.74 446.02 291.74 452.02 291.24V276.74H445.02C445.02 276.74 432.02 276.74 431.8 287.74C431.75 289.95 431.8 298.74 431.8 298.74Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M639.02 300.99H625.68V421.74H639.02V300.99Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M619.68 274.76H614.68V294.56H619.68V274.76Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M641.57 298.99H623.27V303.31H641.57V298.99Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M639.9 298.99H624.68C624.68 292.99 625.68 291.99 619.68 291.49V276.99H626.68C626.68 276.99 639.68 276.99 639.9 287.99C639.95 290.2 639.9 298.99 639.9 298.99Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M649.94 430.09H644.94V449.89H649.94V430.09Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M641.57 421.34H623.27V425.66H641.57V421.34Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M624.71 425.66H639.93C639.93 431.66 638.93 432.66 644.93 433.16V447.66H637.93C637.93 447.66 624.93 447.66 624.71 436.66C624.67 434.44 624.71 425.66 624.71 425.66Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M787.61 432.56H650.02V447.01H787.61V432.56Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M788.02 383.73H725.02V415.91H788.02V383.73Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M792.28 430.03H787.28V449.83H792.28V430.03Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M814.16 454.26H795.86V458.58H814.16V454.26Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M812.49 454.26H797.27C797.27 448.26 798.27 447.26 792.27 446.76V432.26H799.27C799.27 432.26 812.27 432.26 812.49 443.26C812.54 445.47 812.49 454.26 812.49 454.26Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M811.69 458.61H798.35V495.74H811.69V458.61Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M735.29 430.03H730.29V449.83H735.29V430.03Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M780.29 430.03H775.29V449.83H780.29V430.03Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M704.51 455.4L687.01 424.4L704.51 455.4Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M704.51 455.4L687.01 424.4",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M695.21 455.07L678.21 424.48L695.21 455.07Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M695.21 455.07L678.21 424.48",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.88 455.3L249.37 424.3L266.88 455.3Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.88 455.3L249.37 424.3",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.58 454.97L240.58 424.38L257.58 454.97Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.58 454.97L240.58 424.38",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.5099 456.2H33.1699V495.75H46.5099V456.2Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.5098 429.97H52.5098V449.77H57.5098V429.97Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.1501 454.2H30.8501V458.52H49.1501V454.2Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.2902 454.19H47.5102C47.5102 448.19 46.5102 447.19 52.5102 446.69V432.19H45.5102C45.5102 432.19 32.5102 432.19 32.2902 443.19C32.2502 445.41 32.2902 454.19 32.2902 454.19Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.6602 429.97H66.6602V449.77H71.6602V429.97Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.66 429.97H111.66V449.77H116.66V429.97Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.87 422.89H300.57V426.79H318.87V422.89Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.13 416.38H292.73V422.58H326.13V416.38Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.36 399.59H294.66V416.59H324.36V399.59Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.21 382.74H174.84V386.59H224.21V382.74Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.84 378.74H187.02V354.74H212.02V378.74H224.21V382.59H174.84V378.74Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.67 399.89C321.599 399.89 331.27 390.219 331.27 378.29C331.27 366.361 321.599 356.69 309.67 356.69C297.74 356.69 288.07 366.361 288.07 378.29C288.07 390.219 297.74 399.89 309.67 399.89Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.77 397.99C320.65 397.99 329.47 389.17 329.47 378.29C329.47 367.41 320.65 358.59 309.77 358.59C298.89 358.59 290.07 367.41 290.07 378.29C290.07 389.17 298.89 397.99 309.77 397.99Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.02 390.79L298.12 387.79L294.02 390.79Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.02 390.79L298.12 387.79",
    stroke: "#F7F9F9",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.77 390.49L321.07 387.89L324.77 390.49Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.77 390.49L321.07 387.89",
    stroke: "#F7F9F9",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.17 373.49L293.87 373.99L291.17 373.49Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.17 373.49L293.87 373.99",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.87 367.09L296.07 369.09L293.87 367.09Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.87 367.09L296.07 369.09",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.17 362.39L299.97 365.19L298.17 362.39Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.17 362.39L299.97 365.19",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.77 359.74L304.87 363.14L303.77 359.74Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.77 359.74L304.87 363.14",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.02 358.79V362.29V358.79Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.02 358.79V362.29",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.02 359.49L314.72 362.59L316.02 359.49Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.02 359.49L314.72 362.59",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.37 361.89L319.27 364.49L321.37 361.89Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.37 361.89L319.27 364.49",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.37 383.74L291.57 385.04L294.37 383.74Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.37 383.74L291.57 385.04",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.87 377.74L317.07 365.34L309.87 377.74Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.87 377.74L317.07 365.34",
    stroke: "#F7F9F9",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.87 381.19C311.416 381.19 312.67 379.936 312.67 378.39C312.67 376.844 311.416 375.59 309.87 375.59C308.323 375.59 307.07 376.844 307.07 378.39C307.07 379.936 308.323 381.19 309.87 381.19Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.77 378.89H293.37H290.77Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.77 378.89H293.37",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M782.03 389.68H730.32V409.95H782.03V389.68Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M741.02 398.32H762.83V395.32L772.02 399.32L762.83 404.32V401.32H741.02V398.32Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M733.02 429.74V415.74",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M778.02 429.74V415.74",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.89 383.73H60.8901V415.91H123.89V383.73Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.89 389.68H66.1802V409.95H117.89V389.68Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.8901 398.32H98.6901V395.32L107.89 399.32L98.6901 404.32V401.32H76.8901V398.32Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.8901 429.45V415.45",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.89 429.45V415.45",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.52 454.74C213.603 454.74 225.02 447.8 225.02 439.24C225.02 430.68 213.603 423.74 199.52 423.74C185.437 423.74 174.02 430.68 174.02 439.24C174.02 447.8 185.437 454.74 199.52 454.74Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.66 425.74H221.6V451.74H227.66V425.74Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.19 425.74H171.13V451.74H177.19V425.74Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.02 427.99L210.23 428.35C206.731 429.934 202.925 430.723 199.085 430.661C195.244 430.599 191.466 429.687 188.02 427.99V387.74H211.02V427.99Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.52 387.74V429.82",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.86 387.74V429.82",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.19 387.74V429.82",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.52 387.74V429.82",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.68 351.74H200.36C200.797 351.745 201.214 351.922 201.521 352.233C201.828 352.544 202 352.963 202 353.4V354.74H197V353.4C197 353.18 197.044 352.963 197.128 352.76C197.213 352.557 197.337 352.373 197.493 352.219C197.65 352.065 197.835 351.943 198.039 351.86C198.242 351.778 198.46 351.737 198.68 351.74Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M792 156.7H717.8V232.4H792V156.7Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M787.9 159.8H721.3V229.1H787.9V159.8Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M763.2 147.6H744.8V156.5H763.2V147.6Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M759.4 87.74H748.6V147.6H759.4V87.74Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M767.09 62V112V62Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M767.09 62V112",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M774.59 66V108V66Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M774.59 66V108",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M782.09 70V104V70Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M782.09 70V104",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M789.49 74V100V74Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M789.49 74V100",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M797.02 78V96V78Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M797.02 78V96",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M762.6 92.4999H745.29V81.8999H762.6V87.1999V92.4999Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M800.4 87H762.6",
    stroke: "#F7F9F9",
    strokeWidth: 2
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3058_2705"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 854,
    height: 790,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_3058_2705"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 852.21,
    height: 685.04,
    fill: "white",
    transform: "translate(11 62)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGasLiftManager);
export default __webpack_public_path__ + "static/media/gas-lift-manager.cface0b78c08866620c8de291bbed226.svg";
export { ForwardRef as ReactComponent };